import React from 'react'
import { Grid, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'

const TankConfigHeader = ({ title, description, gradientType }) => {
  const primaryGradient = `linear-gradient(135deg, #A5D6A7 0%, #ffffff 100%)`
  const secondaryGradient = 'linear-gradient(135deg, #F4A688 0%, #ffffff 100%)'
  const selectedGradient =
    gradientType === 'primary' ? primaryGradient : secondaryGradient

  return (
    <Grid item xs={12}>
      <div
        style={{
          background: selectedGradient,
          borderRadius: 8,
          padding: 24,
          border: '1px solid #e0e0e0'
        }}
      >
        {/* Title Row */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 8
          }}
        >
          <Typography
            variant="h5"
            color="primary"
            style={{ fontWeight: 'bold' }}
          >
            {title}
          </Typography>
        </div>

        <Typography variant="body2" color="textSecondary" gutterBottom>
          {description}
        </Typography>
      </div>
    </Grid>
  )
}

TankConfigHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  gradientType: PropTypes.oneOf(['primary', 'secondary'])
}

TankConfigHeader.defaultProps = {
  title: 'Additional Tanks Configuration',
  description:
    'Configure additional fuel tanks (Tank 3 onwards) with individual calibration files.',
  gradientType: 'secondary'
}

export default TankConfigHeader



// WEBPACK FOOTER //
// ./src/components/Pages/FuelCalibration/TankConfigHeader.jsx